export default {
  dragAndDrop: 'Drag and Drop',
  chooseAFile: 'Choose a file',
  preview: 'Preview',
};
